/**
 * Popover for image choosing on editor page
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import enhanceWithClickOutside from 'react-click-outside'

import PopoverHeader from './PopoverHeader'
import AssetsSelector from './AssetsSelector'
import UploadAssetsButton from '../assetsManager/UploadAssetsButton'
import CustomCSSView from './customCSS/CustomCSSView'
import { media } from 'components/styles'

const Container = styled.div`
  ${props => props.popoverSection === 'design'
    ? 'width: auto;'
    : 'width: 25em;'}
  ${media.normal`width: 33em;`}
  ${media.huge`width: 40em;`}

  ${media.small`height: 13em;`}
  ${media.normal`height: 40em;`}
  ${media.huge`height: 43em;`}
  ${props => props.popoverSection === 'design'
    ? 'height: 9em !important;'
    : 'height: 33em;'
  }

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border-radius: 8px;
  box-shadow: 0 4px 10px 8px rgba(175,175,175,0.27);

  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 10;
`
const ContentWithTabs = styled.div`
  width: 100%;
  background-color: #fff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  overflow-y: hidden;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
`
const Content = styled.div`
  flex: 1 0 100px;
  position: relative;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
`

class ImagePopover extends Component {

  constructor () {
    super()

    this.state = {
      activeTab: 0
    }
  }

  componentWillMount () {
    this.props.updatePosition('5%', '48%')
  }

  onItemClick = (item) => {
    this.setState({
      activeTab: item.id
    })
  }

  renderAssetsGallery () {
    return (
      <AssetsSelector
        appId={this.props.app.id}
        {...this.props}
      />
    )
  }

  // renderInstagramGallery () {
  //   return (
  //     <InstagramAssetsSelector
  //       appId={this.props.app.id}
  //       {...this.props}
  //     />
  //   )
  // }

  renderEditCSS () {
    return (
      <CustomCSSView
        field={this.props.field}
        app={this.props.app}
      />
    )
  }

  renderContent () {
    switch (this.props.popoverSection) {
      case 'assets':
        return this.renderAssetsGallery()
      case 'design':
        return this.renderEditCSS()
      default:
        return null
    }
  }

  renderUploadAssetsButton () {
    const { app, isVideo, popoverSection } = this.props
    if (popoverSection === 'assets') {
       return <UploadAssetsButton appId={app.id} isVideo={isVideo} />
    }
  }

  render () {
    const { title, closeMyself, app, field } = this.props
    // const tabsInfo = [
    //   {icon: AssetsIcon, name: 'Assets'},
    //   // {icon: InstagramIcon, name: 'Instagram'},
    //   {icon: StyleIcon, name: 'Style'}
    // ]
    return (
      <Container popoverSection={this.props.popoverSection}>
        <PopoverHeader
          headingDescriptor={(this.props.popoverSection === 'assets') ? 'Change ' : 'Design '}
          title={title}
          onClose={closeMyself}
          helpTooltip={'Select the image for this field.  Click the upload button to the left to add new images to your asset library.'}
          additionalBlock={this.renderUploadAssetsButton()}
          app={app}
          field={field}
        />
        <ContentWithTabs>
          {/*<CustomTabs*/}
          {/*activeTab={this.state.activeTab}*/}
          {/*onClick={this.onItemClick}*/}
          {/*tabsInfo={tabsInfo}*/}
          {/*/>*/}
          <Content>
            {this.renderContent()}
          </Content>
        </ContentWithTabs>
      </Container>
    )
  }
}

ImagePopover.propTypes = {
  closeMyself: PropTypes.func,
  title: PropTypes.string,
  app: PropTypes.object.isRequired,
  field: PropTypes.object.isRequired,
  updatePosition: PropTypes.func,
  isVideo: PropTypes.bool,
  popoverSection: PropTypes.string
}


export default enhanceWithClickOutside(ImagePopover)



// WEBPACK FOOTER //
// ./src/components/editor/popovers/ImagePopover.js